// Funciones auxiliares para horarios y prestadores
export const filtrarEspecialidadesVigentes = (especialidades) =>
  especialidades.filter((especialidad) => especialidad.vigente === true);

export const mapEspecialidadesToText = (especialidades) =>
  especialidades.map((especialidad) => ({ ...especialidad, text: especialidad.nombre }));

export const filtrarPrestadoresVigentes = (prestadores) =>
  prestadores.filter((prestador) => prestador.vigente === true);

export const mapPrestadoresToText = (prestadores) =>
  prestadores.map((prestador) => ({ ...prestador, text: prestador.nombre }));
